import React from 'react'
import { Fragment } from 'react'
import Navbar from '../../component/Other/Navbar'
import Head from '../../component/Page/Head'
import Footer from '../../component/Other/Footer'
import FormContact from '../../component/Other/FormContact'

const Contact = () => {
    return (
        <Fragment>
            <div className="overflow-hidden">
                <div className="position-relative">
                    <Navbar />
                    <Head title={"Contact Us"} to={"Contact Us"} />
                </div>

                <section>
                    <div className="container">

                        <div className="row justify-content-center mb__5">
                            <div className="col-md-4 col-lg-3">
                                <div className="d-md-flex text-center align-items-start justify-content-center">
                                    <img src="./../images/a-1.png" className='mb-3 mb-md-0 object-fit-content' alt="" />
                                    <div className="ml-2 font__size--16 text__16-1024">
                                        example@gmai.com
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4 col-lg-3 my-4 my-md-0">
                                <div className="d-md-flex text-center align-items-start justify-content-center">
                                    <img src="./../images/a.png" className='mb-3 mb-md-0 object-fit-content' alt="" />
                                    <div className="ml-2 font__size--16 text__16-1024">
                                        123 Anywhere Street, Any City, 12345 ST, Indonesia
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4 col-lg-3">
                                <div className="d-md-flex text-center align-items-start justify-content-center">
                                    <img src="./../images/a-2.png" className='mb-3 mb-md-0 object-fit-content' alt="" />
                                    <div className="ml-2 font__size--16 text__16-1024">
                                        +123 456 7890
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-4 d-none d-md-block">
                                <img src="./../images/dsffdf.png" alt="" />
                            </div>
                            <div className="col-md-8">
                                <FormContact />
                            </div>
                        </div>
                    </div>
                </section>

                <Footer />
            </div>
        </Fragment>
    )
}

export default Contact